import React, { useMemo } from 'react';

const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

/**
 * Muestra equivalente interno (no sustituye montos legales del comprobante).
 */
const DualCurrencyHint = ({ currency, amount, saleRate, className = '' }) => {
  const equivalent = useMemo(() => {
    const amt = Number(amount);
    const tc = Number(saleRate);
    if (!currency || !Number.isFinite(amt) || !Number.isFinite(tc) || tc <= 0) {
      return null;
    }
    if (currency === 'USD') {
      return { label: 'Equiv. soles', value: round2(amt * tc), code: 'PEN', symbol: 'S/' };
    }
    return { label: 'Equiv. dólares', value: round2(amt / tc), code: 'USD', symbol: 'US$' };
  }, [currency, amount, saleRate]);

  if (!equivalent) return null;

  return (
    <p className={`text-xs text-gray-500 ${className}`}>
      {equivalent.label}: {equivalent.symbol}{' '}
      {equivalent.value.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      {saleRate ? ` (TC venta ${Number(saleRate).toFixed(4)})` : ''}
    </p>
  );
};

export default DualCurrencyHint;
